const store = {
  state: { // 存放当前页面的状态
    token: '',
    islogin: false
  },
  getters: { // 状态的衍生值，其实就是state中的计算属性
  },
  actions: { // 处理组件中的异步操作
    loginsuccess (context) {
      context.commit('changeIsLogin', true)
    },
    loginerror (context) {
      context.commit('changeIsLogin', false)
    }
  },
  mutations: { // 唯一改变当前页面的状态的地方
    changeTokenData (state, data) { // state就是{token: '',islogin: false}
      state.token = data // 改变状态管理器中的数据
    },
    changeIsLogin (state, data) { // state就是{token: '',islogin: false}
      state.islogin = data // 改变状态管理器中的数据
    }
  }
}

export default store
